import { FC, useState, ReactNode } from "react";
import { HeaderCarousel } from "./HeaderCarousel";
import { AnimatePresence, motion } from "motion/react";
import { NavLink } from "react-router";
import Home from "../../assets/icons/home.svg?react";
import Mic from "../../assets/icons/mic.svg?react";
import Disc from "../../assets/icons/disc.svg?react";
import Reel from "../../assets/icons/reel.svg?react";
import CalendarHeart from "../../assets/icons/calendar-heart.svg?react";
import Document from "../../assets/icons/document.svg?react";
import Award from "../../assets/icons/award.svg?react";
import ArrowDown from "../../assets/icons/arrow-down.svg?react";
export type NavItem = {
    label: string;
    icon: ReactNode;
    path: string;
    show: boolean;
}

type NavigationBarProps = {
    onClickNavItem: (item: NavItem) => void;
    onClickRJ?: () => void;
}

const springConfig = {
    type: "spring",
    stiffness: 400,
    damping: 30,
    mass: 0.6
};
const navItems: Array<NavItem> = [
    { label: 'Home', icon: <Home />, path: 'home', show: true },
    { label: 'Audio', icon: <Disc />, path: 'audio', show: true },
    { label: 'Video', icon: <Reel />, path: 'video', show: true },
    { label: 'RJs', icon: <Mic />, path: 'rjs', show: true },
    { label: 'Events', icon: <CalendarHeart />, path: 'events', show: false },
    { label: 'Red Lines', icon: <Document />, path: 'redlines', show: false },
    { label: 'Talent Hunt', icon: <Award />, path: 'talent-hunt', show: false }
];

export const NavigationBarBottom: FC<NavigationBarProps> = ({ onClickNavItem, onClickRJ }) => {
    const [active, setActive] = useState<string>('');

    const onNavItemClick = (event: React.MouseEvent<HTMLAnchorElement>, item: NavItem) => {
        if (item.label === 'RJs') event.preventDefault();
        setActive(active === 'RJs' ? '' : item.label);
        onClickNavItem(item);
    }
    const getClassName = ({ isActive }: { isActive: boolean }) => {
        return `w-full flex flex-col justify-center items-center gap-[8px] text-center  px-4 py-2.5 leading-5 transition-colors duration-500 ${isActive ? 'text-primary-700 font-kanit font-bold' : 'font-inter font-normal'}`
    }

    return (
        <section className="w-full">
            <AnimatePresence>
                <div className="bg-black">
                    {
                        active === 'RJs' && (
                            <motion.div className="md:hidden" key="s"
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: '252px', opacity: 1 }}
                                exit={{ height: 0, opacity: 0 }}
                                transition={{ duration: 0.25, ease: 'easeInOut' }}>
                                <HeaderCarousel onClickProfile={() => { setActive(''); onClickRJ?.(); }} />
                            </motion.div>
                        )
                    }
                </div>
            </AnimatePresence>
            <ul className="flex flex-row items-center justify-between">
                {
                    navItems.filter(item => item.show).map((item, index) => (
                        <li key={index} className="relative w-full md:w-auto flex flex-col">
                            <NavLink to={item.path} type="button" className={getClassName} onClick={(event) => onNavItemClick(event, item)}>
                                <span className="md:hidden">{item.icon}</span>
                                <div className="flex items-center gap-1">
                                    <span className="text-sm leading-none whitespace-nowrap" >{item.label}</span>
                                    {item.label === 'RJs' && <ArrowDown className="hidden md:block" />}
                                </div>
                            </NavLink>
                            {/* <div className="md:peer-hover:visible invisible bg-primary-700 h-0.5 peer-hover:w-full w-0 transition-all absolute left-1/2 -translate-x-1/2 duration-500"></div> */}
                        </li>

                    ))
                }
            </ul>
        </section>
    )
}   